import axios from '@/utils/vuex/client';

export default function logout() {
  axios.delete('/launchpad/v1/logout.json').then(() => {
    window.location.pathname = '/spaces';
  });
}
